
<script>
  import UseResource from 'components/svg/UseResource.svelte';

  export let store;
</script>

<div class="logo">
  {#if store.logo}
    <img src="{store.logo}" alt="{store.name} logo" />
  {:else}
    <UseResource name="ic_store" />
  {/if}
</div>

<style>
  .logo {
    --background: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 72px;
    border-radius: var(--border-radius);
    background: var(--background);
    overflow: hidden;
  }

  .logo img {
    max-width: 100%;
    max-height: 100%;
  }

  .logo :global(.resource) {
    opacity: .5;
  }
</style>
